import { Custom404 } from 'components/pages/Custom404'

export default Custom404
